// `Symbol.toStringTag` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.tostringtag
require('../internals/define-well-known-symbol')('toStringTag');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/es.symbol.to-string-tag.js
// module id = 607
// module chunks = 0